import { IApplicationState } from "..";
import {
  IInformationTypeAccess,
  IInformationTypePermissionSet,
} from "../../models/informationType";
import { StoreState } from "../storeState";

export const selectAvailableInformationTypes = (
  state: IApplicationState
): IInformationTypeAccess[] => state.informationType.available;

export const selectAvailableInformationTypesState = (
  state: IApplicationState
): StoreState => state.informationType.availableState;

export const selectInformationTypePermissionSet = (
  state: IApplicationState
): IInformationTypePermissionSet | null => state.informationType.permissionSet;

export const selectInformationTypePermissionsState = (
  state: IApplicationState
): StoreState => state.informationType.permissionsState;
